import {
	get,
	isEmpty,
} from 'lodash';

async function sha256(message) {
	// encode as UTF-8
	const msgBuffer = new TextEncoder().encode(message);

	// hash the message
	const hashBuffer = await crypto.subtle.digest('SHA-256',
		msgBuffer);

	// convert ArrayBuffer to Array
	const hashArray = Array.from(new Uint8Array(hashBuffer));

	// convert bytes to hex string
	const hashHex = hashArray.map(b => b.toString(16).padStart(2,
		'0')).join('');

	return hashHex;
}

function _getCookie(name) {
	// Split cookie string and get all individual name=value pairs in an array
	var cookieArr = document.cookie && document.cookie.split(';') || [];

	// Loop through the array elements
	for(var i = 0; i < cookieArr.length; i++) {
		var cookiePair = cookieArr[i].split('=');

		/* Removing whitespace at the beginning of the cookie name
        and compare it with the given string */
		if(cookiePair && name == cookiePair[0].trim()) {
			// Decode the cookie value and return
			return decodeURIComponent(cookiePair[1]);
		}
	}

	// Return null if not found
	return null;
}

function _handleProductPrice(product) {
	let price;
	const autoRefill = get(product,
		'options[0].autorefill',
		{});
	// Formatting price
	if (!isEmpty(autoRefill) && autoRefill.selected) {
		if (autoRefill.price_cents) {
			price = autoRefill.price_cents / 100;
		} else {
			price = product.options[0].price_cents / 100;
		}
	} else {
		price = product.options[0].price_cents / 100;
	}
	return price;
}

function _getTreatmentType(product) {
	let treatment_type = product.treatment_type || '';
	if (!treatment_type && product.medication_form) {
		// medication_form is hardcoded or set to the product_type so handle both cases here
		if (product.medication_form === 'Latisse' ||
        product.medication_form === 'LATISSE') {
			treatment_type = 'LASH'
		} else if (product.medication_form === 'Finasteride' ||
               product.medication_form === 'MPB') {
			treatment_type = 'HAIR'
		} else {
			// default everything else to SKIN
			// e.g. medication_form == "Pre Purchase"
			treatment_type = 'SKIN'
		}
	}
	return treatment_type;
}

function _handleItemSetup(products) {
	var items = [];
	var value = 0;
	products.forEach(product => {
		let price = _handleProductPrice(product);
		value += price;
		items.push({
			item_name: product.descriptor_short,
			price,
			item_id: product.id,
			item_brand: 'Apostrophe',
			item_category: `${product.medication_type} ${product.medication_form}`,
			quantity: '1',
			treatment_type: _getTreatmentType(product),
		})
	});
	return {
		items,
		value,
	}
}

function handleRegistrationBeginCheckout(props) {
	const patient = get(props,
		'patient');
	const cart = get(props,
		'cart');
	let tiktokData;
	if (cart) {
		if (cart.product_pre_purchase) { // Google pre purchase
			beginCheckout([{
				descriptor_short: `Google Shopping Credits - ${cart.product_pre_purchase[0].name}`,
				options: [
					{
						price_cents: cart.product_pre_purchase[0].price_cents,
					},
				],
				id: `Google Shopping Credits - ${cart.product_pre_purchase[0].name}${patient ? ` - Patient ${patient.id}` : ''}`,
				medication_type: 'Apostrophe',
				medication_form: 'Pre Purchase',
				treatment_type: 'SKIN', // All rx credit pre-purchases are for SKIN meds (used in _getTreatmentType)
			}],
			false);
			// Tik tok pixel
			tiktokData = {
				content_id: `Google Shopping Credits - ${cart.product_pre_purchase[0].name}${patient ? ` - Patient ${patient.id}` : ''}`,
				content_type: 'product',
				content_name: `Google Shopping Credits - ${cart.product_pre_purchase[0].name}`,
				quantity: 1,
				price: cart.product_pre_purchase[0].price_cents / 100,
				value: cart.product_pre_purchase[0].price_cents / 100,
				currency: 'USD',
			}
			/* Obsolete & sent via GTM instead. Keeping code for reference
      pinterestData = {
        order_id: `Google Shopping Credits - ${cart.product_pre_purchase[0].name}${patient ? ` - Patient ${patient.id}` : ''}`,
        product_id: `Google Shopping Credits - ${cart.product_pre_purchase[0].name}${patient ? ` - Patient ${patient.id}` : ''}`,
        value: cart.product_pre_purchase[0].price_cents / 100,
        order_quantity: 1,
        currency: 'USD',
        line_items: [
          {
            product_name: `Google Shopping Credits - ${cart.product_pre_purchase[0].name}`,
            product_id: `Google Shopping Credits - ${cart.product_pre_purchase[0].name}${patient ? ` - Patient ${patient.id}` : ''}`,
            product_quantity: 1,
            product_price: cart.product_pre_purchase[0].price_cents / 100,
          },
        ],
      } */
		} else if (cart.product) { // Latisse
			beginCheckout([{
				descriptor_short: cart.product.name,
				options: [
					{
						price_cents: cart.product.total_cost * 100,
					},
				],
				id: cart.product.plan_id,
				medication_type: cart.product.name ? cart.product.name : 'Latisse',
				medication_form: cart.product.product_type ? cart.product.product_type : 'Monthly Shipment',
			}],
			false);
			// Tik tok pixel
			tiktokData = {
				content_id: cart.product.plan_id,
				content_type: 'product',
				content_name: cart.product.name,
				quantity: 1,
				price: cart.product.total_cost,
				value: cart.product.total_cost,
				currency: 'USD',
			}
			/* Obsolete & sent via GTM instead. Keeping code for reference
      pinterestData = {
        order_id: cart.product.plan_id,
        product_id: cart.product.plan_id,
        price: cart.product.total_cost,
        value: cart.product.total_cost,
        product_name: cart.product.name,
        order_quantity: 1,
        currency: 'USD',
        line_items: [
          {
            product_name: cart.product.name,
            product_id: cart.product.plan_id,
            product_quantity: 1,
            product_price: cart.product.total_cost,
          },
        ],
      } */
		} else { // Derm visit only
			beginCheckout([{
				descriptor_short: 'Dermatologist Visit',
				options: [
					{
						price_cents: cart.consultation.cost * 100,
					},
				],
				id: `${patient ? `Vist for Patient: ${patient.id}` : 'Derm Visit'}`,
				medication_type: 'Apostrophe',
				medication_form: 'Visit',
			}],
			false);
			// Tik tok pixel
			tiktokData = {
				content_id: `${patient ? `Vist for Patient: ${patient.id}` : 'Derm Visit'}`,
				content_type: 'product',
				content_name: 'Dermatologist Visit',
				quantity: 1,
				price: cart.consultation.cost,
				value: cart.consultation.cost,
				currency: 'USD',
			}
			/* Pinterest pixel - Obsolete & sent via GTM instead. Keeping code for reference
      pinterestData = {
        order_id: `${patient ? `Vist for Patient: ${patient.id}` : 'Derm Visit'}`,
        product_id: `${patient ? `Vist for Patient: ${patient.id}` : 'Derm Visit'}`,
        price: cart.consultation.cost,
        value: cart.consultation.cost,
        product_name: "Dermatologist Visit",
        order_quantity: 1,
        currency: 'USD',
        line_items: [
          {
            product_name: "Dermatologist Visit",
            product_id: `${patient ? `Vist for Patient: ${patient.id}` : 'Derm Visit'}`,
            product_quantity: 1,
            product_price: cart.consultation.cost,
          },
        ],
      } */
		}
		if (typeof ttq !== 'undefined' && ttq && ttq.track) {
			ttq.track('AddToCart',
				tiktokData);
			ttq.track('InitiateCheckout',
				tiktokData);
		}
	}
}

function addShippingInfo() {
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
		event: 'add_shipping_info',
		shipping_tier: 'Standard',
	});
}

// Track patient medical intake responses => push to data layer for tracking via GTM
export function logMedicalIntakePageView(path, eventName) {
	try {
		window.dataLayer = window.dataLayer || [];
		const timestamp = Math.floor(Date.now() / 1000);

		window.dataLayer.push({
			event: eventName,
			path,
			timestamp,
		});
	} catch (error) {
		console.error('Error attempting to log medical intake pageView',
			error.message);
	}
}

function _convertToDisplayText(response, question) {

	if (question.options) {
		let match = question.options.find((option) => option.value === response)
		if (match && match.displayText) {
			return match.displayText
		}
	}

	return response
}

export function logFormAnswers(response, question) {
	try {
		window.dataLayer = window.dataLayer || [];

		if (!Array.isArray(response)) {
			response = [response]
		}

		response = response.map(res => _convertToDisplayText(question.fieldName ? res[question.fieldName] : res,
			question))
		response.forEach(res => {
			window.dataLayer.push({
				event: `form_response-${question.eventName}`,
				response: res,
			});
		})

	} catch (error) {
		console.error('Error attempting to log form answers',
			error.message)
	}
}

function addPaymentInfo(payment_type) {
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
		event: 'add_payment_info',
		ecommerce: {
			payment_type,
		},
	});
	if (typeof ttq !== 'undefined' && ttq && ttq.track) {
		ttq.track('AddPaymentInfo');
	}
}

// Sends begin checkout and addtocart events (since they are the same for us)
function beginCheckout(products, prescriptionCheckout) {
	const {
		items, value,
	} = _handleItemSetup(products,
		prescriptionCheckout);
	let promoCode = _getCookie('promo_code');
	window.dataLayer = window.dataLayer || [];
	let object1 = {
		event: 'begin_checkout',
		ecommerce: {
			items,
			value,
			checkout: prescriptionCheckout ? 'Medication Checkout' : 'Registration Checkout',
		},
	};
	let object2 = {
		event: 'add_to_cart',
		ecommerce: {
			items,
			value,
			checkout: prescriptionCheckout ? 'Medication Checkout' : 'Registration Checkout',
		},
	};
	if (promoCode && promoCode !== '') {
		object1.ecommerce.promotion_name = promoCode;
		object2.ecommerce.promotion_name = promoCode;
	}
	window.dataLayer.push(object1);
	window.dataLayer.push(object2);
}

async function ga4Purchase(response, reportableProducts, patient, isFollowup = false, isSyncPayment = null, isMedPrefsFlow = false) {
	var send_reg_purchase = true;
	var transaction_id = response.charge_id || 'N/A'
	var products = [];
	let checkoutType = isFollowup ? 'Followup Visit Checkout' : 'Registration Checkout';
	if (isMedPrefsFlow) {
		checkoutType = 'Patient Preferences Prepurchase'
	}
	//Product pre purchase (reg checkout)
	if (response.prepurchased_med) {
		checkoutType = 'RX Credit Checkout';
		products.push({
			descriptor_short: response.prepurchased_med,
			options: [
				{
					price_cents: parseInt(response.amount)*10, //Convert back into cents for standardization
				},
			],
			id: `${response.prepurchased_med} - Google Pre Purchase`,
			medication_type: 'Apostrophe',
			medication_form: 'Pre Purchase',
		})
	}
	// Medication checkout handling (this also includes reportableProducts, so we want to exclude those here i.e. if/else)
	if (response.purchased_items) {
		send_reg_purchase = false;
		products = response.purchased_items;
		if (response.rxCredit) {
			checkoutType = 'RX Credit Checkout';
		} else {
			if (!isMedPrefsFlow) {
				checkoutType = 'Medication Checkout';
			}
		}
	} else if (reportableProducts && !isEmpty(reportableProducts)) {
		// Although this is similar to a checkoutType=="Medication Checkout",
		// we still want to categorize this as "Registration Checkout" since it is the initial conversion event
		// Latisse only (reg checkout)
		if (typeof reportableProducts == 'object' && reportableProducts.hasOwnProperty('LATISSE')) {
			products.push({
				descriptor_short: reportableProducts.LATISSE.name,
				options: [
					{
						price_cents: reportableProducts.LATISSE.price_cents, //Convert back into cents for standardization
					},
				],
				id: reportableProducts.LATISSE.plan_id ? reportableProducts.LATISSE.plan_id : reportableProducts.LATISSE.name,
				medication_type: reportableProducts.LATISSE.product_type,
				medication_form: 'Latisse',
				treatment_type: 'LASH',
			});
		} else if (typeof reportableProducts == 'object' && reportableProducts.hasOwnProperty('MPB')) {
			// MPB only (reg checkout)
			products.push({
				descriptor_short: reportableProducts.MPB.name,
				options: [
					{
						price_cents: reportableProducts.MPB.price_cents, //Convert back into cents for standardization
					},
				],
				id: reportableProducts.MPB.plan_id ? reportableProducts.MPB.plan_id : reportableProducts.MPB.name,
				medication_type: reportableProducts.MPB.product_type,
				medication_form: 'Finasteride',
				treatment_type: 'HAIR',
			});
		} else if (Array.isArray(reportableProducts)) {
			// other reportable products
			reportableProducts.forEach((product) => {
				products.push({
					descriptor_short: product.name,
					options: [
						{
							price_cents: product.price_cents, //Convert back into cents for standardization
						},
					],
					id: product.plan_id ? product.plan_id : product.name,
					medication_type: product.product_type,
					medication_form: product.product_type === 'LATISSE' ? 'Latisse' : product.product_type,
					// treatment_type: 'SKIN',
				});
			});
		}
	}
	// Derm visit only (reg checkout)
	if (!response.prepurchased_med && isEmpty(reportableProducts)) {
		products.push({
			descriptor_short: 'Dermatologist Visit',
			options: [
				{
					price_cents: parseInt(response.amount) * 100, //Convert back into cents for standardization
				},
			],
			id: `Visit for Patient: ${patient.id}`,
			medication_type: 'Apostrophe',
			medication_form: 'Visit',
		});
	}

	// Since we don't know what items the patient is actually purchasing in the medication preferences flow, return an empty items list
	const { items } = isMedPrefsFlow
		? { items: [] }
		: _handleItemSetup(products,
			patient.registrationStep !== 'PAYMENT')
	const productForms = products.map(product => {
		if (product.otc_type) {
			product.medication_form = 'OTC'
		}
		return product.medication_form;
	});
	window.dataLayer = window.dataLayer || [];
	// Handle promo codes for any purchase
	window.dataLayer.push({
		event: 'purchase',
		ecommerce: {
			currency: 'USD',
			value: parseInt(response.amount || 0) + '.00',
			affiliation: 'Apostrophe',
			transaction_id,
			items,
			checkout: checkoutType,
			productForms, // includes SKIN rx products (i.e. cream, tablet), OTC, Visit, Pre Purchase, MPB, or Latisse
			isSyncPayment,
		},
	});
	if (send_reg_purchase && patient && patient.hashedEmail) {
		if (typeof ttq !== 'undefined' && ttq && ttq.track) {
			// Tiktok pixel
			ttq.track('PlaceAnOrder',
				{
					content_id: transaction_id,
					content_type: 'product',
					quantity: 1,
					price: parseInt(response.amount || 0) + '.00',
					value: parseInt(response.amount || 0) + '.00',
					currency: 'USD',
				});
		}

		// Reg purchase (for GA4)
		// Primary conversion event
		window.dataLayer.push({
			event: 'reg_purchase',
			hashed_email: patient.hashedEmail,
			currency: 'USD',
			// value is the amount paid by the patient in this transaction (total including discounts)
			value: parseInt(response.amount || 0) + '.00',
			affiliation: 'Apostrophe',
			transaction_id,
			// items contains a list of "retail" prices (not including discounts)
			items,
			productForms, // includes SKIN rx products (i.e. cream, tablet), OTC, Visit, Pre Purchase, or Latisse
		});
		// setTimeout to ensure Google Tag Manager tags have sufficient time to run
		await new Promise(resolve => setTimeout(resolve,
			500));
	}
}

// Used for adding and removing items manually from cart
function triggerCartEvent(product, remove) {
	var event = 'remove_from_cart';
	var price = _handleProductPrice(product);
	if (!remove) {
		event = 'add_to_cart';
	}
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
		event,
		ecommerce: {
			items: [{
				item_name: product.descriptor_short,
				item_id: product.id,
				price,
				item_brand: 'Apostrophe',
				item_category: `${product.medication_type} ${product.medication_form}`,
				quantity: '1',
				treatment_type: _getTreatmentType(product),
			}],
			value: price,
			checkout: 'Medication Checkout',
		},
	});
}

export {
	addPaymentInfo,
	addShippingInfo,
	beginCheckout,
	ga4Purchase,
	handleRegistrationBeginCheckout,
	triggerCartEvent,
}
